import { render, staticRenderFns } from "./LogoutView.vue?vue&type=template&id=f67a9e9a&scoped=true&"
import script from "./LogoutView.vue?vue&type=script&lang=js&"
export * from "./LogoutView.vue?vue&type=script&lang=js&"
import style0 from "./LogoutView.vue?vue&type=style&index=0&id=f67a9e9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67a9e9a",
  null
  
)

export default component.exports